import { action, observable, makeAutoObservable } from "mobx";

import { persistStore } from "src/lib/mobx/persistStore.ts";

class AppStore {
  constructor() {
    makeAutoObservable(this);
  }

  @observable
  debugTranslations = false;

  @action
  setDebugTranslations(state: boolean) {
    this.debugTranslations = state;
  }

  @observable
  debugDbQueries = false;

  @action
  setDebugDbQueries(state: boolean) {
    this.debugDbQueries = state;
  }
}

export const appStore = new AppStore();

export const appStorePersistKey = {
  name: "app_store",
  version: "1.0",
};

const OLD_DEBUG_TRANSLATIONS_KEY = "debugTranslations";
const OLD_DEBUG_QUERIES_KEY = "debugQueries";

const migrateOldLocaleStorageState = () => {
  const debugTranslations = localStorage.getItem(OLD_DEBUG_TRANSLATIONS_KEY);
  const debugDbQueries = localStorage.getItem(OLD_DEBUG_QUERIES_KEY);

  if (debugDbQueries != null) {
    appStore.debugDbQueries = true;
    localStorage.removeItem(OLD_DEBUG_QUERIES_KEY);
  }
  if (debugTranslations != null) {
    appStore.debugTranslations = debugTranslations === "enabled";
    localStorage.removeItem(OLD_DEBUG_TRANSLATIONS_KEY);
  }
};

const { startPersisting } = persistStore(appStore, appStorePersistKey, [
  "debugDbQueries",
  "debugTranslations",
]);

startPersisting();
migrateOldLocaleStorageState();
